export default __webpack_public_path__ + "static/media/duitnow2.53983e3f.png";